import { render } from "./AboutHome.vue?vue&type=template&id=24cdc0a6&scoped=true"
const script = {}

import "./AboutHome.vue?vue&type=style&index=0&id=24cdc0a6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-24cdc0a6"

export default script